// Multi-tenant theming: apply a school's brand colors to CSS variables at runtime.

function hexToRgbTriplet(hex) {
  const h = hex.replace("#", "");
  const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  return `${r} ${g} ${b}`;
}

function hexToHsl(hex) {
  const [r, g, b] = hexToRgbTriplet(hex).split(" ").map((n) => Number(n) / 255);
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0;
  const l = (max + min) / 2;
  const d = max - min;
  if (d !== 0) {
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      default: h = (r - g) / d + 4;
    }
    h /= 6;
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export function applyTheme(theme) {
  if (!theme) return;
  const root = document.documentElement.style;
  if (theme.primary) {
    root.setProperty("--brand-rgb", hexToRgbTriplet(theme.primary));
    root.setProperty("--primary", hexToHsl(theme.primary));
    root.setProperty("--ring", hexToHsl(theme.primary));
  }
  if (theme.accent) {
    root.setProperty("--brand-accent-rgb", hexToRgbTriplet(theme.accent));
  }
}
